const doc = [[({"locale":"de", "title":"Deutsch"}), ({"locale":"en", "title":"English"})]];
module.exports = doc.length <= 1 ? doc[0] : doc;